/* tslint:disable:max-line-length */
import {Injectable, OnDestroy} from '@angular/core';
import {LoadState} from '@docma-mm-core/model/load-state/load-state';
import {LoadStatusEnum} from '@docma-mm-core/model/load-state/load-state.enum';
import {ChangeStatusEnum} from '@docma-mm-core/model/change-state/change-status.enum';
import {Attachment, AttachmentData} from './attachment';
import {Scribble} from '@docma-mm-core/scribble/scribble';

@Injectable()
export class AttachmentDataLoaderService implements OnDestroy {

  ngOnDestroy(): void {
  }

  public mergeWithLoadData(attachments: Attachment[], loadData: Array<AttachmentData>, loadDate?: Date, mergeExisting: boolean = false): {attachment: Attachment, scribbles: Scribble[]}[] {
    loadDate = loadDate ?? new Date(Date.now());
    const oldAttachments = attachments || [];
    const loadAttachmnetsData = loadData ? [...loadData] : [];

    const mergedAttachments: Array<{attachment: Attachment, scribbles: Scribble[]}> = [];

    oldAttachments.forEach(oa => {

      const found = loadAttachmnetsData.find(a => a.UniqueId === oa.uid);
      if (found) {
        oa.loadState = new LoadState({ data: found, date: loadDate, status: LoadStatusEnum.Loaded });
        mergedAttachments.push({
          attachment: oa,
          scribbles: oa.data?.ScribbleLayers?.flatMap(l => l.Scribbles)?.map(sc => new Scribble({loadState: new LoadState({ data: sc, date: loadDate, status: LoadStatusEnum.Loaded })}))
        });
      } else if (oa.isNew || mergeExisting) {
        mergedAttachments.push({
          attachment: oa,
          scribbles: oa.data?.ScribbleLayers?.flatMap(l => l.Scribbles)?.map(sc => new Scribble({loadState: new LoadState({ data: sc, date: loadDate, status: LoadStatusEnum.Loaded })}))
        });
      }
    });

    loadAttachmnetsData.forEach(ad => {
      const mergedAttachment = mergedAttachments.find(ma => ma.attachment.uid === ad.UniqueId);
      if (!mergedAttachment) {
        mergedAttachments.push({
          attachment: new Attachment({loadState: new LoadState({ data: ad, date: loadDate, status: LoadStatusEnum.Loaded })}),
          scribbles: ad.ScribbleLayers?.flatMap(l => l.Scribbles)?.map(sc => new Scribble({loadState: new LoadState({ data: sc, date: loadDate, status: LoadStatusEnum.Loaded })}))
        });
      }
    });

    mergedAttachments.forEach(ma => {
      const unsavedScribbles = (ma.attachment.scribbles ?? []).filter(s =>
        s.changeState?.status === ChangeStatusEnum.New ||
        s.changeState?.status === ChangeStatusEnum.Changed ||
        s.changeState?.status === ChangeStatusEnum.Deleted
      );
      ma.attachment.scribbles = [];
      ma.attachment.addScribbles(ma.scribbles);
      ma.attachment.addScribbles(unsavedScribbles);
    });

    return mergedAttachments.sort((a, b) => {
      const d1 = a.attachment.data.Date != null ? new Date(a.attachment.data.Date).getTime() : 0;
      const d2 = b.attachment.data.Date != null ? new Date(b.attachment.data.Date).getTime() : 0;
      return d2 - d1;
    });

  }

}
